import { ILoginResponse, IRegisterSend } from "@/interfaces/IAuth";
import api from "./api";
import { resetCredentials, setCredentials } from "./slices/authSlice";
import User from "@/interfaces/IUser";
import {
  IForgotPassword,
  IResetPasswordForm,
} from "@/interfaces/ForgotPassword";

export const authApi = api.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<ILoginResponse, any>({
      query: (body) => ({
        url: `/login`,
        method: "POST",
        body,
      }),
      extraOptions: {
        maxRetries: 0,
      },
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        const { data } = await queryFulfilled;
        dispatch(setCredentials(data));
      },
    }),
    loginAs: build.mutation<ILoginResponse, string>({
      query: (id) => ({
        url: `/login/${id}`,
        method: "POST",
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        const { data } = await queryFulfilled;
        dispatch(setCredentials(data));
        dispatch(authApi.util.resetApiState());
      },
    }),
    logout: build.mutation<void, void>({
      query: () => ({
        url: `/logout`,
        method: "POST",
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        await queryFulfilled;
        dispatch(resetCredentials());
        dispatch(authApi.util.resetApiState());
      },
    }),
    register: build.mutation({
      query: (body: IRegisterSend) => ({
        url: `/register`,
        method: "POST",
        body,
      }),
    }),
    forgotPassword: build.mutation<void, IForgotPassword>({
      query: (body) => ({
        url: "/forgot-password",
        method: "POST",
        body,
      }),
    }),
    resetPassword: build.mutation<void, IResetPasswordForm>({
      query: (body) => ({
        url: "/reset-forgot-password",
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useRegisterMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useLoginAsMutation,
} = authApi;
